import { Injectable } from '@angular/core';
import { HttpClient, } from '@angular/common/http';
import { Observable, } from 'rxjs';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';
import { GlobalComponent } from 'src/app/global/global.component';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { GeneralService } from 'src/app/service/general.service';
import { ClientAuthorizationReportBo } from '../../client-parent/client-parent.model';
import { map } from 'rxjs/operators';  
@Injectable()
export class clientinactiveservice extends Subject<DataStateChangeEventArgs>{
    constructor(private http: HttpClient, public global: GlobalComponent, public general: GeneralService, public ngxservice: NgxUiLoaderService) {
    super();
  }
  public execute(state: ClientAuthorizationReportBo): void {
    this.getinactiveclient(state).subscribe(x => super.next(x));
  }

  getinactiveclient(state?: ClientAuthorizationReportBo): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/Client/getInActiveClientReport", state)
      .pipe(map(
        (response: any) => (<any>{

          count: response['count'],
          result: response['result']
        }))

      )
  }

}